import React, { useEffect, useRef, useState } from 'react';
import AddOption from './AddOption';
import RfpInnerText from './rfpInnerBox/RfpInnerText';
import RfpName from './RfpName';
import ActionButtons from './ActionButtons';
import RfpInnerLogo from './rfpInnerBox/RfpInnerLogo';
import RfpSocialLinks from './rfpInnerBox/RfpSocialLinks';
import { cloneDeep, isEqual } from 'lodash';
import useAppState from 'context/useAppState';
import { extractJSONFromText, jsonToMarkdown } from 'utils/function';
import { useParams } from 'react-router-dom';
import Toast from 'components/common/Toast';
import { generatePresignedUrl, uploadFileToS3 } from 'services/auth/auth';
import OverwriteModal from 'components/common/modal/OverwriteModal';
import allImgPaths from 'assets/images';
import HistoryFileUpload from 'components/history/HistoryFileUpload';
import ResizableImage from './ResizableImage';
import CustomDropdown from 'components/common/dropdown/Dropdown';
import { getLLMAgentRAGUpdatePayload } from 'services/llm/payloads';
import { ACTUAL_TASK_NAMES } from 'utils/constant';
import { getAllTitles } from 'services/event';

const subjectText = `<h3>Request for Proposal for Wrestling Competion</h3>`
const aboutText = `<p>Request for Proposal for Solar-Powered Phone Charger Launch Event</p><p>Request for Proposal for Solar-Powered Phone Charger Launch Event</p><p>Request for Proposal for Solar-Powered Phone Charger Launch Event</p><p>Request for Proposal for Solar-Powered Phone Charger Launch Event</p><p>Request for Proposal for Solar-Powered Phone Charger Launch Event</p>`
const descriptionText = `<strong>The name's Sherlock Holmes and the address is 221B Baker street...</strong>`
const scopeText = `<h2>Out of scope</h2>`
const addText = `<p>Some additional text</p>`
const closingText = `<h1>Good luck mate, good luck. You better come victorious this time around. Never let them see you cry</h1>`

const otherItems: any = [
    { showLabel: false, component: <RfpInnerLogo />, content: '', title: '', name: 'RfpInnerLogo', width: '60', height: '60' },
    { showLabel: false, component: <RfpInnerText />, content: '', title: '', name: 'RfpInnerText' },
    { showLabel: false, component: <RfpSocialLinks />, content: '', title: '', name: 'RfpSocialLinks' },
    { showLabel: false, component: <RfpName />, content: '', title: '', name: 'RfpName' }
]

const itemsData: any = [
    { showLabel: false, component: <RfpName />, name: 'RfpName', content: '', title: 'Subject', type: 'text' },
    { showLabel: false, component: <RfpInnerText />, name: 'RfpInnerText', content: '', title: 'About Event', type: 'text' },
    { showLabel: false, component: <RfpInnerText />, name: 'RfpInnerText', content: '', title: 'Description', type: 'text' },
    { showLabel: false, component: <RfpInnerText />, name: 'RfpInnerText', content: '', title: 'Scope', type: 'text' },
    { showLabel: false, component: <RfpInnerText />, name: 'RfpInnerText', content: '', title: 'Additional requirements', type: 'text' },
    { showLabel: false, component: <RfpInnerText />, name: 'RfpInnerText', content: '', title: 'Closing Remarks', type: 'text' }
]

const Rfp = ({ messageData = {} }: any) => {
    // const [items, setItems] = useState(itemsData);  // All the components that are visible in the UI
    const [items, setItems] = useState<any>([]);
    let clonedFormData = useRef(cloneDeep([]));
    const [draftMode, setDraftMode] = useState(true)
    const [showOverwriteModal, setShowOverwriteModal] = useState(false)
    const { selectedCardDetail } = useAppState("cardWrapper");
    const [currentTask, setCurrentTask] = useState<any>(null)
    let { content: messageContent, _id: messageId } = messageData;
    const jsonDetails = messageContent ? extractJSONFromText(messageContent) : {};
    const { content: rfpContent, title: rfpTitle, categories: rfpCategories } = jsonDetails;
    const { id: eventId, draftEventId } = useParams();
    const { setState: setChatMessagesState, updateMessageContent } = useAppState('chatMessages')
    const [saveBtnDisable, setSaveBtnDisable] = useState(false)
    const [isEditMode, setIsEditMode] = useState(jsonDetails?.isEditMode || false)
    // const [title, setTitle] = useState(rfpTitle || '');
    const [title, setTitle] = useState<any>('');
    const [categories, setCategories] = useState<any>(rfpCategories || [])
    const resizedImages = useRef<any>([]);
    const { updateRAGEntryOfFete } = useAppState('chatBox');
    const { setState: setEventDataState, currentTaskObj } = useAppState('eventData');
    const [allTemplateTitles, setAllTemplateTitles] = useState([])

    useEffect(() => {
        fetchAllTitles()
    }, [messageData?.newMessageId])

    useEffect(() => {
        if (!isEditMode) setLLMData()
    }, [])

    useEffect(() => {
        if (isEditMode) fetchData();
    }, [isEditMode, messageData?.newMessageId]);

    useEffect(() => {
        areArraysEqual(items, clonedFormData.current)
    }, [items])

    const fetchAllTitles = async () => {
        const { data } = await getAllTitles({ eventId, template_type: 'rfp' })
        setAllTemplateTitles(data)
    }

    const setLLMData = () => {
        const llmContent = rfpContent;
        const clonedItems = cloneDeep(itemsData);
        clonedItems.map((ci: any, index: number) => {
            if (ci?.title) {
                ci['content'] = llmContent[ci.title]
            }
        })

        setItems(clonedItems)
    }

    const areArraysEqual = (original: any, cloned: any) => {
        const isSame = isEqual(original, cloned);
        setSaveBtnDisable(isSame)
        setEventDataState({ unsavedChanges: !isSame })
    };

    const fetchData = () => {
        const clonedEditItems = cloneDeep(rfpContent?.items || [])
        clonedEditItems.map((ci: any, index: number) => {
            const componentIndex = otherItems.findIndex((oi: any) => oi.name === ci.name);
            if (componentIndex > -1) {
                ci['component'] = otherItems[componentIndex].component
                ci['updatedTime'] = Date.now() + index;
            }
        })

        setItems(clonedEditItems)
        setTitle(rfpTitle)
        setCategories(rfpCategories)
        setDraftMode(true)
        clonedFormData.current = cloneDeep(clonedEditItems);
    };

    const setItemData = (args: any) => {
        const { index, showLabel, content } = args;
        const clonedItems = cloneDeep(items);

        clonedItems[index] = {
            ...clonedItems[index],
            showLabel: showLabel,
            content: content
        };

        setItems(clonedItems)
    }

    const removeItem = (args: any) => {
        const clonedItems = cloneDeep(items);
        const itemIndex = args.index;

        if (itemIndex > -1) {
            const newclonedItems = clonedItems.filter((_: any, i: any) => i !== itemIndex);
            setItems(newclonedItems)
        }
    }

    const dragItem = (args: any) => {
        const { index, position } = args;
        const cleanedItems = cloneDeep(items);

        if (position == 'up') {
            if (index === 0) return;
            const newItems = [...cleanedItems];
            [newItems[index], newItems[index - 1]] = [newItems[index - 1], newItems[index]]; // Swap with the previous item
            setItems(newItems);
        }

        if (position == 'down') {
            if (index === items.length - 1) return;
            const newItems = [...cleanedItems];
            [newItems[index], newItems[index + 1]] = [newItems[index + 1], newItems[index]]; // Swap with the next item
            setItems(newItems);
        }
    }

    const addItem = (args: any) => {
        const insertIndex = args?.index + 1;
        const newItem: any = cloneDeep(otherItems.find((oi: any) => oi.name == args.componentName));
        if (newItem) {
            const uniqueTitles = items.filter((it: any) => it?.title == args?.text);
            newItem['title'] = uniqueTitles?.length > 0 ? `${args.text} - ${Math.floor(1000 + Math.random() * 900)}` : args.text;
            newItem['type'] = args?.type;
            newItem['other'] = args?.other || null

            const clonedItems = cloneDeep(items);
            clonedItems.splice(insertIndex, 0, newItem);
            setItems(clonedItems);
        }
    }

    const previewDraft = () => {
        setDraftMode(false)
    }

    const backtoDrafting = () => {
        setDraftMode(true)
    }

    const uploadFile = async (file: any) => {
        const fileData = {
            file_name: file.name,
            content_type: file.type,
            category: 'document'
        }

        let updatedFileName = null
        try {
            const { data } = await generatePresignedUrl(fileData);

            const payload = {
                url: data.url,
                file: file,
                type: file.type
            }

            if (data) {
                await uploadFileToS3(payload);
                updatedFileName = data?.fileName;
            }
        } catch (error) {
            console.log('Failed to create upload file ', error)
            updatedFileName = null;
        }

        return updatedFileName;
    }

    const save = () => {
        setSaveBtnDisable(true)
        setShowOverwriteModal(true)
        // if (isEditMode) {
        //     setShowOverwriteModal(true)
        // } else {
        //     saveAPICall()
        // }
    }

    const fileToObject = (file: any) => {
        return {
            name: file.name,
            type: file.type,
            size: file.size,
            lastModified: file.lastModified,
            lastModifiedDate: file?.lastModifiedDate,
        };
    }

    const saveAPICall = async (draftTitle?: any) => {
        const filteredData = cloneDeep(items);
        const dataToSave = filteredData.filter((dt: any) => dt?.content || dt?.content?.file)
        const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

        // File upload to S3
        const fileTypes = dataToSave.filter((dt: any) => dt.type == 'image');
        if (fileTypes?.length) {
            for (const fileData of fileTypes) {
                if (fileData?.content?.isNewImageUploaded && fileData?.content?.imageUrl) {
                    const file = fileData.content.file
                    const fileName = await uploadFile(file);
                    fileData.content['imageUrl'] = fileName
                    fileData.content['originalImageUrl'] = fileName;
                    fileData.content['file'] = fileToObject(fileData.content['file'])
                } else {
                    // if (isEditMode) {
                    //     fileData.content['imageUrl'] = fileData.content?.originalImageUrl || ''
                    // }
                }
            }

            for (const fileData of fileTypes) {
                fileData.content['isNewImageUploaded'] = false
            }
        }

        setItems(dataToSave)

        let finalData = dataToSave.map(({ content, name, showLabel, title, type }: any) => ({ content, name, showLabel, title, type }));

        if (resizedImages.current?.length) {
            const clonedFinalData = cloneDeep(finalData)
            for (const imageData of resizedImages.current) {
                clonedFinalData[imageData.index] = {
                    ...clonedFinalData[imageData.index],
                    content: {
                        ...clonedFinalData[imageData.index].content,
                        width: imageData.width,
                        height: imageData.height
                    }
                };
            }
            finalData = clonedFinalData
        }

        // setIsEditMode(false);
        // console.log({ finalData })

        const taskId = currentTask?._id ? currentTask._id : selectedCardDetail?.['tasks'].find((tsk: any) => tsk.title.toLowerCase() == ACTUAL_TASK_NAMES.VENDOR.VENUE.toLowerCase())?._id;

        const updatedTitle = draftTitle ? draftTitle : (title ? title : "Event Program Draft")
        const messagePayload = {
            content: JSON.stringify({ 'isRFP': true, title: updatedTitle, categories, 'items': finalData }),
            teamId: currentTeam?.currentTeamId,
            eventId: eventId,
            is_draft: false,
            taskId: taskId || currentTaskObj?.task_id,
            cardId: selectedCardDetail?._id,
            blockId: selectedCardDetail?.columnId || selectedCardDetail?.block_id
        }

        if (!messagePayload.taskId) {
            Toast.error('', 'Task Id not available')
            setSaveBtnDisable(false)
            return
        }

        // console.log({ messagePayload, messageId })

        if (isEditMode) {
            clonedFormData.current = cloneDeep(items)
            areArraysEqual(items, cloneDeep(items))
        }

        try {
            await updateMessageContent(messageId, messagePayload)
        } catch (error) {
            handleApiCases(false)
        }

        if (!isEditMode) {
            setSaveBtnDisable(true)
        }

        setEventDataState({ unsavedChanges: false })

        await handleRAGCall({ content: finalData })

        handleApiCases(true)
    }

    const handleRAGCall = async ({ content }: any) => {
        const userData = JSON.parse(localStorage.getItem('userData') as string)
        const userEmail = localStorage.getItem('userEmail')
        const currentTeam = JSON.parse(localStorage.getItem('selectedTeam') as string)

        let ragPayload: any = {
            text_content: jsonToMarkdown({ content: content, isRFP: true }),
            text_prefix: 'RFP',
        }

        const isDraft = draftEventId ? true : false

        const taskId = currentTask?._id ? currentTask._id : selectedCardDetail?.['tasks'].find((tsk: any) => tsk.title.toLowerCase() == ACTUAL_TASK_NAMES.VENDOR.VENUE.toLowerCase())?._id;
        const ragMetaData = {
            userId: userData?.id,
            userEmail,
            teamId: currentTeam?.currentTeamId,
            eventId: eventId,
            is_draft: isDraft,
            taskId: taskId || currentTaskObj?.task_id,
            updatedAt: new Date().toISOString(),
            cardId: selectedCardDetail?._id
        }

        ragPayload = { ...ragPayload, document_path: messageId, additional_metadata: ragMetaData }

        try {
            await updateRAGEntryOfFete(getLLMAgentRAGUpdatePayload(ragPayload))
        } catch (error) {
            handleApiCases(false)
        }
    }

    const handleApiCases = (isSuccess: boolean) => {
        if (isSuccess) {
            Toast.success('', 'Saved successfully')
        } else {
            Toast.error('', 'Failed to save')
        }
    }

    const confirmNew = async (title: any) => {
        setShowOverwriteModal(false)
        const timestamp = Math.floor(new Date().getTime() / 1000).toString(16);
        const random = 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
            return ((Math.random() * 16) | 0).toString(16);
        }).toLowerCase();
        const newMessageID = timestamp + random;

        messageId = newMessageID;
        messageData._id = newMessageID;

        const draftTitle = title ? title : rfpTitle
        setTitle(draftTitle)
        saveAPICall(draftTitle)
    }

    const confirmOverwrite = async (title: any) => {
        setShowOverwriteModal(false)
        const draftTitle = title ? title : rfpTitle
        setTitle(draftTitle)
        saveAPICall(draftTitle)
    }

    const getFileExtension = (filename: any) => {
        const imageExts = ['png', 'jpg', 'jpeg'];
        const fileExtension = filename.split('.').pop()
        return imageExts.includes(fileExtension)
    }

    const handleResize = (index: any, dimensions: any) => {
        const clonedItems = cloneDeep(items);
        clonedItems[index] = {
            ...clonedItems[index],
            other: { ...dimensions }
        };

        const resizedImageIndex = resizedImages.current.findIndex((ri: any) => ri?.index == index);
        if (resizedImageIndex > -1) {
            resizedImages.current[resizedImageIndex] = { width: dimensions.width, height: dimensions.height, index }
        } else {
            resizedImages.current.push({ width: dimensions.width, height: dimensions.height, index })
        }
    };

    const cancel = () => {
        setSaveBtnDisable(false)
    }

    return (
        <>
            {
                showOverwriteModal &&
                <OverwriteModal
                    draftTitle={title}
                    headerText={'Save the Draft'}
                    bodyText={isEditMode ? `Do you want to update this draft or save a new?` : ''}
                    setShowOverwriteModal={setShowOverwriteModal}
                    confirmNew={confirmNew}
                    confirmOverwrite={confirmOverwrite}
                    cancel={cancel}
                    btnGroup={isEditMode ? 'isEditMode' : 'isCreateMode'}
                    allTemplateTitles={allTemplateTitles}
                />
            }
            <div className='border border-[#EAECF0] rounded-bl-lg rounded-br-lg rounded-tr-lg py-2.5 px-3.5 bg-[#F9FAFB] mb-8'>
                {
                    draftMode &&
                    <p className='text-base text-[#101828] pb-2.5 font-interMedium'>Sure, here's the RFP draft</p>
                }
                {/* <div>
                    <div className="w-full py-2 pr-2">
                        <div className="mb-2 flex justify-between items-center px-0.5">
                            <span className='font-bold text-x text-[#000]'>Title</span>
                        </div>

                        <div className="border border-[#EAECF0] rounded-lg px-4 py-3 bg-[#fff] flex items-center">
                            <input
                                onChange={(e) => setTitle(e.target.value)}
                                className='w-full placeholder:text-base placeholder:text-[#D0D5DD] pr-4'
                                placeholder='Enter here'
                                type="text"
                                value={title}
                                readOnly={!draftMode}
                            />
                        </div>
                    </div>
                </div>  */}

                {
                    draftMode &&
                    <div className="border border-[#EAECF0] py-6 px-3 bg-[#fff]">
                        {items.map((item: any, index: number) => (
                            <React.Fragment key={`${item.title}-${index}`}>
                                {
                                    React.cloneElement(item.component, {
                                        data: { ...item },
                                        index,
                                        setItemData,
                                        removeItem,
                                        dragItem
                                    })
                                }
                                <AddOption index={index} addItem={addItem} />
                            </React.Fragment>
                        ))}

                        <div className='flex justify-end items-center gap-x-4'>
                            <ActionButtons buttonClass={`submit-btn-blue hover:bg-[#120693]`} previewDraft={previewDraft} text={'Preview Draft'} />
                            <ActionButtons
                                buttonClass={`submit-btn-blue hover:bg-[#120693] ${saveBtnDisable ? 'button-disabled' : ''}`}
                                previewDraft={save}
                                text={'Save'}
                                disabled={saveBtnDisable}
                            />
                        </div>
                    </div>
                }
                {
                    !draftMode &&
                    <div>
                        <div>
                            {
                                items?.length && items.map((fd: any, index: number) => (
                                    <React.Fragment key={index}>
                                        <div>
                                            {
                                                fd?.showLabel &&
                                                <label>
                                                    <strong>{fd?.title}</strong>
                                                </label>
                                            }
                                            {
                                                (fd.type == 'text' || fd.type == 'number') &&
                                                <>
                                                    <br />
                                                    {
                                                        fd.title != 'Social Links' &&
                                                        <div
                                                            suppressContentEditableWarning={true}
                                                            className={`pr-14 no-css mb-3`}
                                                            dangerouslySetInnerHTML={{ __html: fd?.content }}
                                                        >
                                                        </div>
                                                    }
                                                    {
                                                        fd.title == 'Social Links' &&

                                                        fd?.content?.length > 0 && fd.content.map((con: any, index: number) => (
                                                            <React.Fragment key={index}>
                                                                <label>
                                                                    <strong>{con?.title}</strong>:
                                                                    <span className='ml-1.5'>{con?.value}</span>
                                                                </label>
                                                                <div>
                                                                </div>
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </>
                                            }
                                            {
                                                fd.type == 'image' && fd.name == 'RfpInnerLogo' &&
                                                <>
                                                    {
                                                        getFileExtension(fd.content.filename) &&
                                                        <div className="w-60 h-60 rounded border border-[#ddd] p-2 overflow-hidden">
                                                            <ResizableImage
                                                                key={index}
                                                                imageData={{
                                                                    content: fd.content,
                                                                    isEditMode,
                                                                    updatedTime: Math.random()
                                                                }}
                                                                index={index}
                                                                onResize={handleResize}
                                                            />
                                                        </div>
                                                    }
                                                    {
                                                        !getFileExtension(fd.content.filename) &&
                                                        <div>
                                                            <HistoryFileUpload
                                                                fileName={fd?.content?.filename}
                                                                fileSize={null}
                                                                contentType={'isRFP'}
                                                            />
                                                        </div>
                                                    }
                                                </>
                                            }

                                        </div>
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    </div>
                }

            </div>
            {
                !draftMode &&
                <div className='flex justify-end items-center gap-x-4'>
                    <ActionButtons buttonClass={`font-interSemiBold text-[#344054] hover:bg-[#F2F4F7] border border-[#E8E6FE] rounded-lg cursor-pointer`} previewDraft={backtoDrafting} text={'Back to Drafting'} />
                    <ActionButtons
                        buttonClass={`submit-btn-blue hover:bg-[#120693] ${saveBtnDisable ? 'button-disabled' : ''}`}
                        previewDraft={save}
                        text={'Save'}
                        disabled={saveBtnDisable}
                    />
                </div>
            }

            {/* <RfpVendorBoxModal /> */}
        </>
    );
};

export default Rfp;
